'use strict';
var util = angular.module('gymsystem.util');
util.controller('TrainingCardPayments', ['$scope', 'trainingCard', 'server', '$modal', '$rootScope', '$location', '$modalStack', 'eventlog', 'Link', 'live', '$q', '$filter', 'paymentMethods', 'formatter', 'alertProvider', 'util', function ($scope, trainingCard, server, $modal, $rootScope, $location, $modalStack, eventlog, Link, live, $q, $filter, paymentMethods, formatter, alertProvider, util) {
        var payments, frozenPeriods, result;
        $scope.noPayments = function () {
            if ($scope.loading)
                return false;
            return !result || !result.length;
        };
        $scope.nextPayment = null;
        function trainingCardChanged() {
            if ($scope.loading)
                return;
            server.post2('/api/payment/generate_next/probe', {
                trainingcard_id: trainingCard.id
            }).then(function (p) {
                $scope.nextPayment = null;
                if (!p)
                    return;
                var f = formatter.format;
                var method = f('translated', getMethod(p));
                $scope.nextPayment = "".concat(f('date', p.date), " ").concat(f('price', p.amount), " [").concat(f('date', p.from_date), " - ").concat(f('date', p.to_date), "] ").concat(method);
            }, function () { return $scope.nextPayment = null; });
        }
        ;
        $scope.makeNextPayment = function () {
            $scope.loading = true;
            server.post2('/api/payment/generate_next', {
                trainingcard_id: trainingCard.id
            }).then(function () {
                reload().then(function () {
                    $scope.loading = false;
                    trainingCardChanged();
                });
            });
        };
        $scope.getReceipt = function () {
            var card = trainingCard;
            var doGet = function (fromDate, toDate, mail) {
                $scope.gettingReceipt = true;
                var args = { id: card.id, fromDate: fromDate, toDate: toDate, mail: mail };
                server.get('/api/trainingcard/receipt/get', args, null, { responseType: 'blob' }).then(function (data) {
                    if (mail) {
                        alertProvider.modal('Collection receipt', 'Mail sent');
                    }
                    else {
                        util.download($filter('translate')('Collection receipt') + '.pdf', data, 'application/pdf');
                    }
                    $scope.gettingReceipt = false;
                }, function () {
                    alertProvider.modal('Failed', 'Failed to get receipt');
                    $scope.gettingReceipt = false;
                });
            };
            $modal.open({
                templateUrl: '/views/tcardperiod.html',
                controller: 'TrainingCardPeriodCtrl',
                resolve: {
                    card: function () { return card; },
                    options: function () { return ({ mail: true }); }
                }
            }).result.then(function (data) {
                doGet(data.fromDate, data.toDate, data.mail);
            });
        };
        live.subscribe({
            type: 'trainingcard',
            scope: $scope,
            callback: function (tc) {
                if (tc.id != trainingCard.id)
                    return;
                trainingCard = $rootScope.transformTrainingCard(tc);
                if (!$scope.loading) {
                    trainingCardChanged();
                    reload();
                }
            }
        });
        live.subscribe({
            type: 'payment',
            scope: $scope,
            callback: function (_, msg) {
                if (!payments)
                    return;
                for (var _i = 0, _a = msg.data; _i < _a.length; _i++) {
                    var a = _a[_i];
                    for (var _b = 0, payments_1 = payments; _b < payments_1.length; _b++) {
                        var b = payments_1[_b];
                        if (a.id === b.id) {
                            reload();
                            return;
                        }
                    }
                }
            }
        });
        function rebuild() {
            var r = [];
            if (payments && payments.length)
                r.push.apply(r, payments);
            if (frozenPeriods && frozenPeriods.length)
                r.push.apply(r, frozenPeriods);
            result = r.sort(function (a, b) {
                var a_fromDate = a.from_date || a.fromDate;
                var b_fromDate = b.from_date || b.fromDate;
                if (!a_fromDate || !b_fromDate) {
                    if (a_fromDate)
                        return 1;
                    if (b_fromDate)
                        return -1;
                    if (a.date && b.date && a.date != b.date)
                        return a.date - b.date;
                    return 0;
                }
                return a_fromDate - b_fromDate;
            });
        }
        ;
        function reload() {
            return $q.promise(function (resolve, reject) {
                var a = server.post2('/api/payment/get_list', {
                    trainingcard_id: trainingCard.id
                }).then(function (result) {
                    payments = result;
                    rebuild();
                });
                var b = server.post2('/api/trainingcard/freeze/get', {
                    trainingcard_id: trainingCard.id
                }).then(function (result) {
                    frozenPeriods = result.map(function (f) { return (f.frozen = true, f); });
                    rebuild();
                });
                return $q.all([a, b]);
            });
        }
        ;
        var editPayment = function (p) {
            if (p.frozen) {
                return;
            }
            if (p.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard')) {
                return;
            }
            server.get('/api/payment/get', { member: p.member_id, payment_id: p.id }).then(function (payments) {
                payments = payments.map($rootScope.transformPayment);
                $modal.open({
                    templateUrl: 'views/payment.html',
                    controller: 'PaymentModalCtrl',
                    resolve: {
                        payment: function () {
                            return payments[0];
                        }
                    }
                });
            });
        };
        $scope.openLogs = function () {
            eventlog.openDialog({
                filter: new Link('trainingcard', Number(trainingCard.id)),
                noPeriod: true,
                hideFilter: true
            });
        };
        var openPaymentLog = function (p) {
            eventlog.openDialog({
                filter: new Link('payment', Number(p.id)),
                noPeriod: true,
                hideFilter: true
            });
        };
        var getPeriod = function (p) {
            if (p.from_date)
                return p.from_date.yyyymmdd() + ' - ' + p.to_date.yyyymmdd();
            if (p.fromDate)
                return p.fromDate.yyyymmdd() + ' - ' + p.toDate.yyyymmdd();
        };
        var getStatus = function (p) {
            return { failed: 'Failed', paid: 'Paid', sent: 'Sent', credited: 'Credited', pending: 'Pending' }[p.status] || p.status;
        };
        var getMethod = function (p) {
            var _a;
            var method = _.findWhere(paymentMethods.getAll(), { id: p.method });
            // If method is not found, its a payment from a frozen period
            var methodName = (_a = method === null || method === void 0 ? void 0 : method.name) !== null && _a !== void 0 ? _a : "Frozen period";
            return methodName;
        };
        $scope.table = {
            getItems: function () { return result; },
            rowClick: editPayment,
            hideSearch: true,
            columns: [
                { field: 'date', title: 'Date', format: 'date' },
                {
                    field: 'amount',
                    title: 'Amount',
                    format: 'discountedprice',
                    getExtraValue: function (i) { return i.discount; }
                },
                { field: 'period', title: 'Period', getValue: getPeriod },
                { field: 'method', title: 'Payment method', format: 'translated', getValue: getMethod },
                { field: 'status', title: 'Payment status', format: 'translated', getValue: getStatus }
            ],
            buttons: [
                { title: 'Event log', buttonClass: 'btn-info', onClick: openPaymentLog, visible: function (p) { return !p.frozen && $scope.hasPermission('Show event log'); } }
            ]
        };
        $scope.createPaymentForPeriod = function () {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                resolve: {
                    trainingcard: function () {
                        return trainingCard;
                    },
                    customer: function () {
                        return $rootScope.getMember(trainingCard.user_id);
                    }
                },
                controller: ['$rootScope', '$scope', '$controller', 'util', 'trainingcard', 'customer', function ($rootScope, $scope, $controller, util, trainingcard, customer) {
                        $controller('AddCtrl', { $scope: $scope });
                        $scope.postUrl = '/api/payment/add';
                        $scope.callCloseOnSuccess = true;
                        $scope.item = {
                            payer_id: customer,
                            from_date: trainingcard.generatedUntil ? Date.newFull(trainingcard.generatedUntil).addDays(1) : null,
                            to_date: trainingcard.generatedUntil ? Date.newFull(trainingcard.generatedUntil).addDays(1).lastDayThisMonth() : null,
                            amount: Number(trainingcard.price)
                        };
                        $scope.submit = function () {
                            $scope.loadingStatus.loading = true;
                            var item = $scope.getSubmitItem();
                            item.trainingcard_id = trainingcard.id;
                            item.member_id = customer.id;
                            if (item.method == 'invoice' || item.method == 'einvoice') {
                                item.date = _.findWhere($scope.fields, { name: 'sendDate' }).value.clone().addDays(item.days).yyyymmdd();
                            }
                            server.post($scope.postUrl, [item], null, 'Payment added', 'Failed to add payment').then(function (result) {
                                $scope.loadingStatus.loading = false;
                                if (result.success) {
                                    $scope.resetForm($scope);
                                    $scope.possiblyClose(result.data);
                                }
                            });
                        };
                        var onMethodChange = function () {
                            var method = _.findWhere($scope.fields, { name: 'method' }).value;
                            var newDate = Date.today();
                            if (method.id == 'directdebit') {
                                newDate = util.getBillingDate();
                            }
                            _.findWhere($scope.fields, { name: 'date' }).value = newDate;
                        };
                        var isInvoice = function () {
                            var method = _.findWhere($scope.fields, { name: 'method' });
                            return method.value && (method.value.id == 'invoice' || method.value.id == 'einvoice');
                        };
                        var isNotInvoice = function () {
                            return !isInvoice();
                        };
                        var hasSavedCard = function () {
                            var payer = _.findWhere($scope.fields, { name: 'payer_id' }).value;
                            return payer.hasSavedCardForSelectedLegalEntity();
                        };
                        var getAmountFieldValue = function () {
                            var fields = $scope.fields || [];
                            var field = _.findWhere(fields, { name: 'amount' });
                            return util.parseDecimal(field && field.value);
                        };
                        var hasMoney = function () {
                            var payer = _.findWhere($scope.fields, { name: 'payer_id' }).value;
                            var amount = getAmountFieldValue();
                            if (isNaN(amount)) {
                                return false;
                            }
                            return payer.getValueCardAmountForSelectedLegalEntity() >= amount;
                        };
                        var showInvoiceFreeText = function () {
                            var payMethod = _.findWhere($scope.fields, { name: 'method' }).value;
                            return payMethod && payMethod.id === 'invoice';
                        };
                        var onToDateChange = function () {
                            var fromDate = _.findWhere($scope.fields, { name: 'from_date' }).value;
                            var toDate = _.findWhere($scope.fields, { name: 'to_date' }).value;
                            fromDate = fromDate.clearTime();
                            toDate = toDate.clearTime();
                            if (toDate && toDate > Date.today().addDays(365)) {
                                alertProvider.show('error', 'Check that the date seems reasonable');
                            }
                            var amountField = _.findWhere($scope.fields, { name: 'amount' });
                            // Only support to calculate amount if it is monthly payment card
                            if (fromDate && toDate && amountField && trainingcard.cardtype.priceType == 'Month') {
                                var totalAmount = 0;
                                var current = fromDate.clone();
                                var pricePerMonth = Number(trainingcard.price);
                                // Need to calculate the amount for each month in the period to get correct amount
                                while (current <= toDate) {
                                    var monthStart = current.firstDayThisMonth();
                                    var monthEnd = current.lastDayThisMonth();
                                    var daysInMonth = current.getDaysInMonth();
                                    var calcStart = (current.isSameDateAs(fromDate) || fromDate > monthStart) ? fromDate : monthStart;
                                    var calcEnd = (toDate < monthEnd) ? toDate : monthEnd;
                                    var days = calcStart.daysUntil(calcEnd) + 1;
                                    totalAmount += ((pricePerMonth / daysInMonth) * days);
                                    current = monthEnd.clone().addDays(1);
                                }
                                amountField.value = Math.round(totalAmount);
                            }
                            else if (fromDate && toDate && toDate < fromDate) {
                                alertProvider.show('error', 'Check that the date seems reasonable');
                            }
                        };
                        var onDateChange = function () {
                            var date = _.findWhere($scope.fields, { name: 'date' }).value;
                            if (date && date > Date.today().addDays(180)) {
                                alertProvider.show('error', 'Check that the date seems reasonable');
                            }
                        };
                        $scope.fields = [
                            { name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', change: onMethodChange, options: { create: true }, hasSavedCard: hasSavedCard, hasMoney: hasMoney },
                            { name: 'comment', title: 'Product comment', required: false, type: 'textarea' },
                            { name: 'from_date', title: 'Period - start', required: true, type: 'date' },
                            { name: 'to_date', title: 'Period - end', required: true, type: 'date', change: onToDateChange },
                            { name: 'sendDate', title: 'Invoice date', required: true, type: 'date', visible: isInvoice },
                            { name: 'days', title: 'Payment terms', required: true, type: 'infoNumber', info: 'days', visible: isInvoice, min: 1 },
                            { name: 'date', title: 'Due date', required: true, type: 'date', visible: isNotInvoice, change: onDateChange },
                            { name: 'amount', title: 'Amount', required: true, type: 'price' },
                            { name: 'payer_id', title: 'Payer', required: true, type: 'customer', useId: true },
                            { name: 'invoiceExtraInfo', title: 'Invoice comment (max 150 characters)', required: false, visible: showInvoiceFreeText, type: 'textarea', maxlength: 150 },
                        ];
                        util.setValues($scope.fields, $scope.item);
                    }]
            }).result.then(function (result) {
                reload();
            });
        };
        // Included-product cards (a sub-product bundled into a parent card) are
        // controlled through their parent
        $scope.isIncludedProduct = function () {
            return !!trainingCard.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard');
        };
        $scope.canPayOffTrainingCard = function () {
            return (payments && payments.filter(function (p) { return p.status == 'pending'; }).length > 0) || (trainingCard.cardtype.auto && !trainingCard.validToDate);
        };
        $scope.payOffTrainingCard = function () {
            $modal.open({
                templateUrl: 'views/payofftrainingcard.html',
                resolve: {
                    trainingcard: function () {
                        return trainingCard;
                    },
                    customer: function () {
                        return $rootScope.getMember(trainingCard.user_id);
                    },
                    payments: function () {
                        return payments;
                    }
                },
                controller: ['$rootScope', '$scope', '$controller', 'util', 'formatter', 'trainingcard', 'customer', 'payments', 'cashiers', '$location', 'modalUtils', 'alertProvider', 'server', function ($rootScope, $scope, $controller, util, formatter, trainingcard, customer, payments, cashiers, $location, modalUtils, alertProvider, server) {
                        $controller('AddCtrl', { $scope: $scope });
                        $scope.title = 'Pay off training card';
                        var highestAmount = 0;
                        var totalDiscount = 0;
                        var canbepaid;
                        var giftcard;
                        var codeError;
                        var setCanBePaid = function () {
                            canbepaid = payments.filter(function (p) { return p.status == 'pending'; }).sort(function (a, b) {
                                var a_fromDate = a.from_date || a.fromDate;
                                var b_fromDate = b.from_date || b.fromDate;
                                if (!a_fromDate || !b_fromDate) {
                                    if (a_fromDate)
                                        return 1;
                                    if (b_fromDate)
                                        return -1;
                                    if (a.date && b.date && a.date != b.date)
                                        return a.date - b.date;
                                    return 0;
                                }
                                return a_fromDate - b_fromDate;
                            });
                            highestAmount = 0;
                            totalDiscount = 0;
                            canbepaid.forEach(function (p) {
                                highestAmount += Number(p.amount);
                                totalDiscount += Number(p.discount || 0);
                            });
                        };
                        setCanBePaid();
                        var autoCard = trainingcard.cardtype.auto;
                        var canCreateNewPayments = function () {
                            return autoCard && !trainingcard.validToDate;
                        };
                        $scope.item = {
                            payer_id: customer,
                            amount: highestAmount
                        };
                        var getRemaining = function () {
                            var payAmount = getAmountFieldValue();
                            if (isNaN(payAmount)) {
                                return;
                            }
                            var amountLeft = payAmount;
                            var paymentsLeft = canbepaid.length;
                            canbepaid.forEach(function (p) {
                                if (amountLeft > 0) {
                                    if (amountLeft >= p.amount) {
                                        paymentsLeft -= 1;
                                    }
                                    amountLeft -= Math.min(p.amount, amountLeft);
                                }
                            });
                            return paymentsLeft + ' ' + util.t('payments') + ', ' + formatter.format('price', highestAmount - payAmount);
                        };
                        var getPayOffInfo = function () {
                            var payAmount = getAmountFieldValue();
                            var amountLeft = isNaN(payAmount) ? 0 : payAmount;
                            var info = {
                                payments: [],
                                splitPayment: null,
                                splitAmount: 0
                            };
                            canbepaid.forEach(function (p) {
                                if (amountLeft > 0) {
                                    if (amountLeft < p.amount) {
                                        info.splitPayment = p;
                                        info.splitAmount = amountLeft;
                                        var part = amountLeft / p.amount;
                                        var from = Date.newFull(p.from_date);
                                        var to = Date.newFull(p.to_date);
                                        // Rounded, since a DST night is 23 or 25 hours
                                        var days = Math.round((to.getTime() - from.getTime()) / 86400000) + 1;
                                        // Leave at least one day for the remaining payment
                                        var paidDays = Math.min(Math.ceil(part * days), days - 1);
                                        info.splitFromDate = from;
                                        info.splitEndDate = to;
                                        if (paidDays > 0) {
                                            info.splitPaidToDate = from.clone().addDays(paidDays - 1);
                                            info.splitRestFromDate = from.clone().addDays(paidDays);
                                        }
                                        else {
                                            // A one-day period can't be divided, so both parts keep it
                                            info.splitPaidToDate = to;
                                            info.splitRestFromDate = from;
                                        }
                                    }
                                    else {
                                        info.payments.push(p);
                                    }
                                    amountLeft -= Math.min(p.amount, amountLeft);
                                }
                            });
                            return info;
                        };
                        var getAmountFieldValue = function () {
                            var fields = $scope.fields || [];
                            var field = _.findWhere(fields, { name: 'amount' });
                            return util.parseDecimal(field && field.value);
                        };
                        var getNewPaymentsCount = function () {
                            var payAmount = getAmountFieldValue();
                            if (isNaN(payAmount)) {
                                return 0;
                            }
                            if (payAmount > highestAmount) {
                                payAmount -= highestAmount;
                                return Math.ceil(payAmount / trainingcard.price);
                            }
                            return 0;
                        };
                        var getMethod = function () {
                            var method = _.findWhere($scope.fields, { name: 'method' }).value;
                            return method && method.id;
                        };
                        var getAmount = function () {
                            return getAmountFieldValue();
                        };
                        var giftCardOk = function () {
                            var cardAmount = giftcard && giftcard.paid && giftcard.card ? util.parseDecimal(giftcard.card.amount) : NaN;
                            var amount = getAmount();
                            if (isNaN(cardAmount) || isNaN(amount)) {
                                return false;
                            }
                            return !codeError && cardAmount >= amount;
                        };
                        var setCodeError = function (e) {
                            codeError = e;
                            _.findWhere($scope.fields, { name: 'codeError' }).hint = util.t(e);
                        };
                        var getGiftCard = function () {
                            giftcard = null;
                            codeError = null;
                            var code = _.findWhere($scope.fields, { name: 'code' }).value;
                            if (!code) {
                                return;
                            }
                            var site = $rootScope.sites.find(function (x) { return x.id == trainingcard.site_id; });
                            var legal_entity_id = site ? site.legal_entity_id : null;
                            server.get('/api/public/giftcard/verify', { code: code, legal_entity_id: legal_entity_id }).then(function (response) {
                                if (code == _.findWhere($scope.fields, { name: 'code' }).value) {
                                    if (response.found) {
                                        giftcard = response;
                                        if (response.expired) {
                                            setCodeError('The gift card expired on {0} and is no longer valid.'.format(response.expired));
                                        }
                                        else if (response.wrong_legal_entity) {
                                            setCodeError('Gift card belongs to a different legal entity');
                                        }
                                        else if (!util.parseDecimal(response.card.amount)) {
                                            setCodeError('There is no money left on the gift card');
                                        }
                                        else if (!response.paid) {
                                            setCodeError('Gift card is not paid');
                                        }
                                    }
                                    else {
                                        setCodeError('Gift card could not be found');
                                    }
                                }
                            });
                        };
                        var getRemainingGiftCardBalance = function () {
                            if (!giftcard) {
                                return null;
                            }
                            var cardAmount = util.parseDecimal(giftcard.card.amount);
                            var amount = getAmount();
                            if (isNaN(cardAmount) || isNaN(amount)) {
                                return null;
                            }
                            return cardAmount - amount;
                        };
                        if (canCreateNewPayments()) {
                            $scope.fields = [
                                { type: 'label', title: 'Training card', value: trainingcard.cardtype_name },
                                { name: 'method', title: 'Payment method', options: { markAsPaid: true }, type: 'paymentmethod' },
                                { name: 'amount', title: 'Amount', required: true, type: 'number', min: 1 },
                                { type: 'label', title: 'Number of new payments', getValue: getNewPaymentsCount },
                                { name: 'code', title: 'Gift card code', required: true, type: 'text', visible: function () { return getMethod() == 'giftcard'; }, change: getGiftCard },
                                { name: 'amount', title: 'Left on gift card after purchase', type: 'label', getValue: getRemainingGiftCardBalance, visible: function () { return getMethod() == 'giftcard' && giftcard; }, format: 'price' },
                                { name: 'codeError', hint: '', hintClass: 'alert-danger', visible: function () { return getMethod() == 'giftcard' && codeError; } },
                                { hint: 'Not enough money on gift card', hintClass: 'alert-danger', visible: function () {
                                        if (!(getMethod() == 'giftcard' && giftcard)) {
                                            return false;
                                        }
                                        var cardAmount = util.parseDecimal(giftcard.card.amount);
                                        var amount = getAmount();
                                        if (isNaN(cardAmount) || isNaN(amount)) {
                                            return false;
                                        }
                                        return cardAmount < amount;
                                    } }
                            ];
                        }
                        else {
                            $scope.fields = [
                                { type: 'label', title: 'Training card', value: trainingcard.cardtype_name },
                                { type: 'label', title: 'Number of payments', value: canbepaid.length },
                                { type: 'labelhtml', title: 'Left to pay', getValue: function () { return formatter.format('discountedprice', highestAmount, totalDiscount); } },
                                { name: 'method', title: 'Payment method', options: { markAsPaid: true }, type: 'paymentmethod' },
                                { name: 'amount', title: 'Amount', required: true, type: 'number', max: highestAmount, min: 1 },
                                { type: 'label', title: 'Remains after payment', getValue: getRemaining, visible: getRemaining },
                                { name: 'code', title: 'Gift card code', required: true, type: 'text', visible: function () { return getMethod() == 'giftcard'; }, change: getGiftCard },
                                { name: 'amount', title: 'Left on gift card after purchase', type: 'label', getValue: getRemainingGiftCardBalance, visible: function () { return getMethod() == 'giftcard' && giftcard; }, format: 'price' },
                                { name: 'codeError', hint: '', hintClass: 'alert-danger', visible: function () { return getMethod() == 'giftcard' && codeError; } },
                                { hint: 'Not enough money on gift card', hintClass: 'alert-danger', visible: function () {
                                        if (!(getMethod() == 'giftcard' && giftcard)) {
                                            return false;
                                        }
                                        var cardAmount = util.parseDecimal(giftcard.card.amount);
                                        var amount = getAmount();
                                        if (isNaN(cardAmount) || isNaN(amount)) {
                                            return false;
                                        }
                                        return cardAmount < amount;
                                    } }
                            ];
                        }
                        $scope.alertNotEnoughMoney = function () {
                            if ($scope.loadingStatus.loading) {
                                return;
                            }
                            var method = _.findWhere($scope.fields, { name: 'method' }).value;
                            if (!method || method.id != 'valuecard') {
                                return;
                            }
                            var amount = getAmountFieldValue();
                            if (isNaN(amount)) {
                                return;
                            }
                            if (!payments || payments.length == 0) {
                                return;
                            }
                            var payer = $rootScope.getMember(payments[0].payer_id);
                            if (!payer) {
                                return;
                            }
                            return Number(payer.getValueCardAmountForSelectedLegalEntity()) < amount;
                        };
                        $scope.canPayOff = function () {
                            return getMethod() && !$scope.alertNotEnoughMoney() && (getMethod() != 'giftcard' || giftCardOk());
                        };
                        $scope.canCheckout = function () {
                            var amount = getAmountFieldValue();
                            return !isNaN(amount);
                        };
                        var doPayOff = function (payments, checkout) {
                            if (checkout) {
                                payments = payments.map($rootScope.transformPayment);
                                var method = _.findWhere($scope.fields, { name: 'method' }).value;
                                // Legacy in-memory transfer for the old Angular Kassa.
                                cashiers.transfer({ payments: payments, method: method && method });
                                $scope.$close();
                                // URL params for the new StaffNext checkout, which reads
                                // `payment_ids` from `route.query`. Same pattern as
                                // `checkoutPayment` in economy.js.
                                var ids = _.pluck(payments, 'id').filter(Boolean);
                                var search = {};
                                if (ids.length)
                                    search.payment_ids = ids.join(',');
                                var firstPayer = payments[0] && (payments[0].payer_id || payments[0].user_id);
                                if (firstPayer)
                                    search.customer_id = firstPayer;
                                $location.path('/checkout').search(search);
                                modalUtils.closeAllModals();
                            }
                            else {
                                var ids = _.pluck(payments, 'id');
                                var date = Date.today().yyyymmdd();
                                var method = _.findWhere($scope.fields, { name: 'method' }).value;
                                var code = _.findWhere($scope.fields, { name: 'code' }).value;
                                server.post('/api/payment/markAsPaid', null, { payments: ids, date: date, method: method.id, code: code }, 'Payment was marked as paid', 'Failed to mark payment as paid').then(function (result) {
                                    $scope.loadingStatus.loading = false;
                                    if (result.success) {
                                        $scope.$close();
                                    }
                                });
                            }
                        };
                        $scope.payOff = function (checkout) {
                            $scope.loadingStatus.loading = true;
                            var doSplit = function () {
                                var topay = getPayOffInfo();
                                if (topay.splitPayment) {
                                    var data = {
                                        original_payments: [topay.splitPayment.id],
                                        new_payments: [
                                            { amount: topay.splitAmount, method: topay.splitPayment.method, from_date: topay.splitFromDate.yyyymmdd(), to_date: topay.splitPaidToDate.yyyymmdd() },
                                            { amount: topay.splitPayment.amount - topay.splitAmount, method: topay.splitPayment.method, from_date: topay.splitRestFromDate.yyyymmdd(), to_date: topay.splitEndDate.yyyymmdd() }
                                        ],
                                        method: topay.splitPayment.method
                                    };
                                    server.post('/api/payment/split', data).then(function (result) {
                                        if (result.success) {
                                            topay.payments.push(result.data[0]);
                                            doPayOff(topay.payments, checkout);
                                        }
                                        else {
                                            alertProvider.show('error', 'Failed to split payment');
                                            $scope.loadingStatus.loading = false;
                                        }
                                    });
                                }
                                else {
                                    doPayOff(topay.payments, checkout);
                                }
                            };
                            var payAmount = getAmountFieldValue();
                            var proceedIfCovered = function () {
                                server.post2('/api/payment/get_list', {
                                    trainingcard_id: trainingCard.id
                                }).then(function (result) {
                                    payments = result;
                                    setCanBePaid();
                                    if (payAmount > highestAmount) {
                                        alertProvider.show('error', 'Unable to generate enough pending payments to cover the entered amount');
                                        $scope.loadingStatus.loading = false;
                                        return;
                                    }
                                    doSplit();
                                });
                            };
                            if (canCreateNewPayments() && payAmount > highestAmount) {
                                server.post2('/api/payment/generate_next', {
                                    trainingcard_id: trainingCard.id,
                                    pay_amount: payAmount
                                }).then(proceedIfCovered, function () {
                                    alertProvider.show('error', 'Failed to generate payments');
                                    $scope.loadingStatus.loading = false;
                                });
                            }
                            else {
                                doSplit();
                            }
                        };
                        util.setValues($scope.fields, $scope.item);
                    }]
            }).result.then(function (result) {
                reload();
            });
        };
        trainingCardChanged();
        reload();
    }]);
